<template>
    <div>
        <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Buscar menu"
            dense
            outlined
            clearable
            hide-details
            class="mb-3"
        />

        <v-card outlined>
            <v-card-title class="py-2 subtitle-2 grey--text text--darken-2">
                <v-icon small color="grey darken-1" class="mr-2">mdi-sitemap</v-icon>
                Permissão em menu
                <v-spacer />
                <v-chip x-small label outlined color="primary">{{ selected.length }} selecionado(s)</v-chip>
            </v-card-title>
            <v-divider />
            <v-card-text
                :style="scrollable ? { maxHeight: maxHeight + 'px', overflowY: 'auto' } : {}"
            >
                <div v-if="loading" class="text-center grey--text py-4">
                    <v-progress-circular indeterminate size="22" color="grey" />
                </div>
                <template v-else>
                    <v-treeview
                        v-if="menus.length"
                        v-model="selected"
                        :items="menus"
                        :search="search"
                        selectable
                        selection-type="independent"
                        item-text="name"
                        dense
                        @input="apply"
                    />
                    <div v-else class="text-center grey--text py-4 caption">Nenhum menu disponível.</div>
                </template>
            </v-card-text>
        </v-card>
    </div>
</template>

<script setup>

import { defineProps, defineEmits, ref, watch, onBeforeMount } from 'vue'
import { useStore } from '@/composables/useStore'

const store = useStore()

const props = defineProps({
    value: { type: Array, default: () => [] },
    // Quando true, a lista de itens (v-card-text) ganha altura máxima fixa
    // com rolagem própria — "Buscar menu" e o título ficam de fora dessa
    // área e permanecem sempre visíveis. Sem isso, mantém o comportamento
    // padrão (sem rolagem própria), usado na tela de Perfis.
    scrollable: { type: Boolean, default: false },
    maxHeight: { type: [Number, String], default: 240 }
})
const emit = defineEmits(['input'])

const menus = ref([])
const search = ref('')
const loading = ref(true)
const selected = ref([...(props.value || [])])

watch(() => props.value, (val) => {
    const next = [...(val || [])]
    if (JSON.stringify(next) !== JSON.stringify(selected.value)) selected.value = next
})

const apply = () => emit('input', [...selected.value])

onBeforeMount(async () => {
    try {
        const res = await store.dispatch('menu/ActionFindMenus')
        menus.value = res.data || []
        // Reaplica a seleção após os itens carregarem — o v-treeview só reconcilia
        // o v-model quando os :items já estão presentes na renderização.
        selected.value = [...(props.value || [])]
    } finally {
        loading.value = false
    }
})

</script>
